import { useEffect, useState } from "react";
import { API_URL } from "../config/site";

let cache = null;

export function useProducts() {
  const [products, setProducts] = useState(cache || []);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    if (cache) return;
    fetch(`${API_URL}/products`)
      .then((r) => r.json())
      .then((data) => {
        cache = data;
        setProducts(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return { products, loading };
}

export function useProduct(slug) {
  const { products, loading } = useProducts();
  return { product: products.find((p) => p.slug === slug) || null, loading };
}
